import { apiRoot } from "./apiRoot";

const authEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["Auth"],
});

type LoginResultData = {
  message: string;
  redirect: string | null;
  success: boolean;
};

export type LoginRequestData = {
  rd: string;
  email: string;
  password: string;
  remember?: "on" | undefined;
};

const authApi = authEndpoints.injectEndpoints({
  endpoints: (builder) => {
    return {
      login: builder.mutation<LoginResultData, LoginRequestData>({
        query: (loginFormData) => ({
          url: `/login`,
          method: "POST",
          body: loginFormData,
          formData: true,
        }),
      }),
    };
  },
});

export const { useLoginMutation } = authApi;
